import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetIndividualSubmittedResponsesRPC } from "./getIndividualSubmittedResponsesRPC";

export class GetIndividualSubmittedResponsesRPCClientImpl extends GetIndividualSubmittedResponsesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetIndividualSubmittedResponsesRPC.Request): Promise<LeoRPCResult<GetIndividualSubmittedResponsesRPC.Response, GetIndividualSubmittedResponsesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetIndividualSubmittedResponses",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetIndividualSubmittedResponsesRPC.ResponseDTO,
      GetIndividualSubmittedResponsesRPC.Errors.ErrorsDTO,
      GetIndividualSubmittedResponsesRPC.Response,
      GetIndividualSubmittedResponsesRPC.Errors.Errors
    >(
      response,
      "respondent/GetIndividualSubmittedResponses",
      GetIndividualSubmittedResponsesRPC.Response.fromDTO,
      GetIndividualSubmittedResponsesRPC.Errors.fromDTO
    );
  }
}
